import React from "react";
import SectionHeader from "../Common/Section-Header/SectionHeader";
import EventCard from "./Event-Card/EventCard";
import Slider from "react-slick";
import Fade from "react-reveal/Fade";
import EventsData from "data/events.json";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Events.scss";

const Events = () => {
  const eventsDataWithId = EventsData.map((data, index) => ({
    id: index + 1,
    ...data,
  }));

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="section-separator" id="events">
      <div className="container mb-5">
        <Fade bottom>
          <SectionHeader
            subtitle="Something for the community"
            title="Events Gallery"
          />
        </Fade>
        <Fade>
          <div className="row mt-5">
            <Slider {...settings}>
              {eventsDataWithId.map((event) => (
                <EventCard
                  key={event.id}
                  title={event.title}
                  venue={event.venue}
                  date={event.date}
                  image={event.image}
                />
              ))}
            </Slider>
          </div>
        </Fade>
      </div>
    </section>
  );
};

export default Events;
